export default "__VITE_ASSET__455ecb54__"